// ABOUTME: Action modal for invoice grid actions - add concept invoice and import adjustment charges
// ABOUTME: Displays a popover modal with action buttons for invoice management
import { Box, useTheme } from "@mui/material";

import AddIcon from '@mui/icons-material/Add';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { useTranslation } from "react-i18next";
import { tokens } from "../../../../theme";
import PopoverModal from "../../../theme/Modal/PopoverModal";
import Text from "../../../theme/text/Text";
import { ActionButton } from "./components/ActionButton";
import { ActionIcon } from "./components/ActionIcon";


export const AMInvoiceActions = (props) => {
    const theme = useTheme();
    const {t} = useTranslation();
    const colors = tokens(theme.palette.mode);
    let isStandAlone = false;
    if (window.matchMedia('(display-mode: standalone)').matches) {
        isStandAlone = true;
    }

    return (
        <PopoverModal
            {...props}
        >
            <Box
                sx={{
                    background: theme.palette.mode === "dark" ? colors.grey[100] : "#fff",
                    padding:1.5,
                    paddingBottom: isStandAlone ? 4 : 1.5,
                    display:"flex",
                    gap:1,
                    flexDirection:"column",
                    borderRadius:"24px",
                    borderBottomLeftRadius:0,
                    borderBottomRightRadius:0,
                    "@media screen and (max-width: 48em)" : {
                        borderRadius:"32px",
                        borderBottomLeftRadius:0,
                        borderBottomRightRadius:0,

                    }
                }}
            >
                <ActionButton
                    onClick={() => {
                        props.onClose();
                        props.onAddConceptInvoice();
                    }}
                >
                    <ActionIcon>
                        <AddIcon fontSize="small"/>
                    </ActionIcon>
                    <Box>
                        <Text>
                            {t('new_concept_invoice')}
                        </Text>
                    </Box>
                </ActionButton>
                <ActionButton
                    onClick={() => {
                        props.onClose();
                        props.onFinalizeAllInvoices();
                    }}
                >
                    <ActionIcon>
                        <CheckCircleOutlineIcon fontSize="small"/>
                    </ActionIcon>
                    <Box>
                        <Text>
                            {t('finalize_all_invoices')}
                        </Text>
                    </Box>
                </ActionButton>
                <ActionButton
                    onClick={() => {
                        props.onClose();
                        props.onImportAdjustmentCharges();
                    }}
                >
                    <ActionIcon>
                        <FileUploadIcon fontSize="small"/>
                    </ActionIcon>
                    <Box>
                        <Text>
                            {t('import_adjustment_charges')}
                        </Text>
                    </Box>
                </ActionButton>
            </Box>
        </PopoverModal>
    );
}
